export const trustindex = () => {
  const sections = document.querySelectorAll('section.trustindex')
  
  if (!sections) return

  sections.forEach(section => {
    const script = section.querySelector('script')
    const container = section.querySelector('.container')
    const newScript = document.createElement('script')
    newScript.src = script.src
    script.remove()
    container.appendChild(newScript)
  })
}

export default () => {}